import { useEffect } from 'react';

export const useImagePreload = (imageSrc: string) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = imageSrc;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [imageSrc]);
};
